import {
    GET_LEADS_CAP_VALUATION_REQUEST,
    GET_LEADS_CAP_VALUATION_REQUEST_SUCCESS,
    GET_LEADS_CAP_VALUATION_REQUEST_FAILURE,
} from '../../constants/cap.constants';

export const getLeadsCapValuationRequest = (derivative_id, full_year, year, year_code, mileage, _id) => ({
    type: GET_LEADS_CAP_VALUATION_REQUEST, derivative_id, full_year, year, year_code, mileage, _id,
});
export const getLeadsCapValuationRequestSuccess = (payload) => ({ type: GET_LEADS_CAP_VALUATION_REQUEST_SUCCESS, payload });
export const getLeadsCapValuationRequestFailure = (error) => ({ type: GET_LEADS_CAP_VALUATION_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/cap_actions/get_cap_valuation.actions.js